import { QuestionElementProps } from "@/components/questionnaire/components/element.type.ts";
import { getFormKey } from "@/components/questionnaire/questionnaire.types.ts";
import { Stack, Textarea } from "@skailer-com/uikit";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export const CommentElement: React.FC<QuestionElementProps> = ({ element }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation();
  const formElementName = getFormKey(element, true);
  return (
    <>
      <Stack>
        <Controller
          name={formElementName}
          control={control}
          render={({ field }) => (
            <Stack>
              <Textarea
                label={t("surveys:add_comment_to_your_answer") + "..."}
                {...field}
                error={errors[formElementName]?.message as string | undefined}
              />
            </Stack>
          )}
        />
      </Stack>
    </>
  );
};
